import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { SubscriptionBundlesVM } from '../../viewModel/subscriptionBundles.viewModel';

export type ConfirmPriceChangeModalProps =
  SubscriptionBundlesVM['confirmPriceModal'];

export const ConfirmPriceChangeModal: React.FC<
  ConfirmPriceChangeModalProps
> = ({ isOpen, save, close, priceConfirm }) => (
  <Modal
    isOpen={isOpen}
    onClose={close}
    title="Exclusive Access price change"
    modalClassName="w-full md:w-[670px]"
  >
    <div
      className={sprinkles({
        display: 'flex',
        flexDirection: 'column',
        gap: 'xl',
      })}
    >
      {priceConfirm.monthly && (
        <DetailsCard isMonthly={true} price={priceConfirm.monthly} />
      )}
      {priceConfirm.annual && (
        <DetailsCard isMonthly={false} price={priceConfirm.annual} />
      )}
      <div
        className={sprinkles({
          display: 'flex',
          gap: 'l',
          justifyContent: 'end',
          alignItems: 'center',
        })}
      >
        <Button
          variant="text"
          color="neutral"
          onClick={close}
          className="w-[220px]"
          data-testid="subscription-cancel-price-change"
        >
          Cancel
        </Button>
        <Button
          color="neutral"
          onClick={save}
          className="w-[200px]"
          data-testid="subscription-confirm-price-change"
        >
          Save
        </Button>
      </div>
    </div>
  </Modal>
);

const DetailsCard = ({
  isMonthly,
  price,
}: {
  isMonthly: boolean;
  price: string;
}) => (
  <div
    className={sprinkles({
      display: 'flex',
      flexDirection: 'column',
      gap: 'l',
      p: 'l',
      borderRadius: 'm',
      bg: 'N-10',
    })}
  >
    <Typography variant="body" size="small" fontWeight="bold">
      {isMonthly ? 'MONTHLY' : 'ANNUAL'} SUBSCRIBERS
    </Typography>
    <div
      className={sprinkles({
        display: 'flex',
        flexDirection: 'column',
        gap: '2xl',
      })}
    >
      <Typography variant="body" fontWeight="normal">
        All <b>new {isMonthly ? 'monthly' : 'annual'} subscribers</b> will join
        your channel at <b>${price}</b> / {isMonthly ? 'month' : 'year'} from
        now on.
      </Typography>
      <Typography variant="body" fontWeight="normal">
        All the <b>existing {isMonthly ? 'monthly' : 'annual'} subscribers</b>{' '}
        will continue at their current prices, you can find more details in the
        Analytics section.
      </Typography>
    </div>
  </div>
);
